import { jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import {
  useAddFieldValidation,
  useFormField
} from "@workwave-tidal/form-fairy";
import {
  TimePicker as TimePickerComponent
} from "@workwave-tidal/core/components";
import { useValidateOn } from "../../hooks/useValidateOn.js";
import { FormUIFormControl } from "../primitives/FormUIFormControl.js";
const noopOnValidate = () => {
};
function TimePicker(props) {
  const { name, testId, fullWidth, onValidate = noopOnValidate, onValidateOptions, ...otherFieldOptions } = props;
  const {
    field,
    errors,
    formApi,
    fieldApi: { change: apiChange, validate }
  } = useFormField(
    name,
    otherFieldOptions
  );
  const { validateOnChange } = useValidateOn(validate, "change");
  const changeAndValidate = useCallback(
    (value2) => {
      apiChange(value2);
      validateOnChange();
    },
    [validateOnChange, apiChange]
  );
  const options = useMemo(
    () => Object.assign({}, onValidateOptions, { disabled: onValidate === noopOnValidate }),
    [onValidate, onValidateOptions]
  );
  useAddFieldValidation(
    name,
    //@ts-expect-error FIXME
    onValidate,
    options
  );
  const { value, required, disabled, visible } = field;
  if (!visible) return null;
  const fieldDisabled = disabled || formApi.getMeta().submitting || formApi.getMeta().disabled;
  const error = errors.length > 0 ? errors[0].message : void 0;
  return /* @__PURE__ */ jsx(FormUIFormControl, { "data-testid": testId, "data-tidal": "TimePicker", fullWidth, children: /* @__PURE__ */ jsx(
    TimePickerComponent,
    {
      name,
      value,
      error,
      required,
      disabled: fieldDisabled,
      onChange: changeAndValidate,
      ...otherFieldOptions
    }
  ) });
}
export {
  TimePicker
};
//# sourceMappingURL=TimePicker.js.map
